import './Settings.scss'
import {useDispatch, useSelector} from "react-redux";
import Toggle from "../util/Toggle.jsx";
import {
    getIsAthGolden,
    getIsZeroBaseValue,
    getShowLatestValue,
    getShowTxAnnotations,
    getShowTxAnnotationsDividends,
    setIsAthGolden,
    setIsZeroBaseValue,
    setShowLatestValue,
    setShowTxAnnotations,
    setShowTxAnnotationsDividends,
} from "../../ducks/chart-duck.js";
import InternalLink from "../util/navigation/InternalLink.jsx";
import {closePopup} from "../../ducks/popup-duck.js";
import MessageAlertOutlineIcon from "mdi-react/MessageAlertOutlineIcon.js";
import {useAnnotationLink} from "../annotation/useAnnotationLink.js";

export default () => {

    const dispatch = useDispatch()
    const showLatestValue = useSelector(getShowLatestValue)
    const isZeroBaseValue = useSelector(getIsZeroBaseValue)
    const isAthGolden = useSelector(getIsAthGolden)
    const showTxAnnotations = useSelector(getShowTxAnnotations)
    const showTxAnnotationsDividends = useSelector(getShowTxAnnotationsDividends)

    const {annotationRoute} = useAnnotationLink()

    const onClickClosePopup = () => dispatch(closePopup())

    return (
        <div className='settings'>
            <h2>
                Settings
            </h2>
            <h3>
                Chart
            </h3>
            <div className='toggle-container'>
                <Toggle
                    isChecked={showLatestValue}
                    onChange={value => dispatch(setShowLatestValue(value))}
                >
                    Show line for latest value
                </Toggle>
            </div>
            <div className='toggle-container'>
                <Toggle
                    isChecked={isAthGolden}
                    onChange={value => dispatch(setIsAthGolden(value))}
                >
                    Golden color when ATH
                </Toggle>
            </div>
            <div className='toggle-container'>
                <Toggle
                    isChecked={isZeroBaseValue}
                    onChange={value => dispatch(setIsZeroBaseValue(value))}
                >
                    Zero base value
                </Toggle>
            </div>
            <div className='toggle-container'>
                <Toggle
                    isChecked={showTxAnnotations}
                    onChange={value => dispatch(setShowTxAnnotations(value))}
                >
                    Show transaction markers
                </Toggle>
                {showTxAnnotations &&
                <div className='toggle-container sub-toggle'>
                    <Toggle
                        isChecked={showTxAnnotationsDividends}
                        onChange={value => dispatch(setShowTxAnnotationsDividends(value))}
                    >
                        Include dividends &amp; burns
                    </Toggle>
                </div>
                }
            </div>
            <br/>
            <div className='link-list'>
                <ul>
                    <li>
                        <InternalLink
                            to={annotationRoute}
                            icon={<MessageAlertOutlineIcon/>}
                            onClick={onClickClosePopup}
                        >
                            Manage annotations
                        </InternalLink>
                    </li>
                </ul>
            </div>
        </div>
    )
}